var exports = {
  "kL": "xfd349460--368441--container",
  "kA": "xfd349460--368441--logo-block",
  "wm": "xfd349460--368441--logo",
  "VY": "xfd349460--368441--info-block",
  "nf": "xfd349460--368441--link",
};

module.exports = exports;
